module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text"
  }, [_c('div', {
    staticStyle: {
      "font-size": "0.6rem",
      "display": "none"
    },
    attrs: {
      "id": "prompt"
    }
  }, [_vm._v("您的消息已经收到啦， 客服人员会尽快回复的。")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.content),
      expression: "content"
    }],
    attrs: {
      "placeholder": "按 回车键(换行) 发送"
    },
    domProps: {
      "value": (_vm.content)
    },
    on: {
      "keyup": _vm.onKeyup,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.content = $event.target.value
      }
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-163567e5","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Message/MessageText.vue
// module id = 1547
// module chunks = 8